import { Edit } from "@mui/icons-material";
import { GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";

export default function EditButton({ rowID, setRowModesModel }) {
  const handleClick = () =>
    setRowModesModel((rowModesModel) => {
      return {
        ...rowModesModel,
        [rowID]: { mode: GridRowModes.Edit },
      };
    });

  return (
    <GridActionsCellItem icon={<Edit />} label={"Edit" }onClick={handleClick} />
  );
}
